var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableActionButton',{attrs:{"label":_vm.$t('sampleProgress.files.download'),"button-icon":"fas fa-download","button-color":"green","disabled":_vm.downloading,"click-function":_vm.download}})
}
var staticRenderFns = []

export { render, staticRenderFns }